import type { FaireProductEntity } from "../../entity_types/product";

export const p_twucgt6bs6: FaireProductEntity = {
  token: "p_twucgt6bs6",
  type: "product",
  name: "Peony flower scented candle  candle gift",
  brandToken: "b_3zvyk2yn8q",
  brandName: "Little Trendy",
  imageUrl:
    "https://cdn.faire.com/fastly/860898b59ae74ba002e372d9c8214f17809b311e806fefa6b737584510b68fd7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f817984b615a5b8d11a3d4161b23a05494ed9ae618bc0d54c33698746fb03e41.jpeg",
    "https://cdn.faire.com/fastly/beefd837dd6eedbe7682dde1f9b7ad9d440df84ee94710c544f0dc3188b26019.jpeg",
    "https://cdn.faire.com/fastly/73ec51b480198ce578d7f88ad10b6dc7acd3451c724666b950b389628d48da1e.png",
    "https://cdn.faire.com/fastly/b9b5cbbf85a7033c4694456599edbcd83a10105058e4159b4fbd5e029b1f074b.png",
    "https://cdn.faire.com/fastly/bf2119d0313373f16e822747215a089512d34c76c777a1bdbe4b1be4d28152cd.png",
    "https://cdn.faire.com/fastly/69c47ee082b1a0286116cb790f4d863af02c3b6861b373a91dd91d0dea022a05.png",
    "https://cdn.faire.com/fastly/5f7044cf9a6f19a61ab24ecafab5c2ce0dd632dcfd5addaa5992ca4f5929c22b.png",
    "https://cdn.faire.com/fastly/f52628f727ec238fee90ce152156bc01d9390384572ccce6c7d01a820f14f75b.png",
    "https://cdn.faire.com/fastly/a06522e6fb4d4d3d7c806948e5c805f320fb46e0ef989404f757843f5efefd18.png",
    "https://cdn.faire.com/fastly/7ded9ba64377b87b5cab03afb7c27509697346a374b32152d5dd639fdbff0fc4.png",
  ],
  priceDollars: 5.99,
  description:
    "\nProduct material: 80% fully refined paraffin wax (commonly used in food, pharmaceutical packaging, lipstick raw materials, etc.) \n20% soy wax (extracted from natural soybean oil)\nProduct application: home decoration, gifts\nBurning time: 5-7h (for reference only)\n\n",
  tags: [],
  msrpDollars: 11.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:26.703Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
